import React from 'react';
import { Form, Button, ButtonGroup } from 'react-bootstrap';

/**
 * Create / Edit mode toggle for forms.
 * @param {string} mode - 'create' | 'edit'
 * @param {function} onModeChange - (mode: 'create' | 'edit') => void
 * @param {string} [createLabel='Create']
 * @param {string} [editLabel='Edit']
 */
const FormModeToggle = ({ mode, onModeChange, createLabel = 'Create', editLabel = 'Edit' }) => (
  <Form.Group className="mb-3">
    <Form.Label>Action</Form.Label>
    <ButtonGroup className="d-block">
      <Button
        variant={mode === 'create' ? 'primary' : 'outline-primary'}
        onClick={() => onModeChange('create')}
      >
        {createLabel}
      </Button>
      <Button
        variant={mode === 'edit' ? 'primary' : 'outline-primary'}
        onClick={() => onModeChange('edit')}
      >
        {editLabel}
      </Button>
    </ButtonGroup>
  </Form.Group>
);

export default FormModeToggle;
